// Map various country name formats to ISO 3-letter codes
const countryVariations = {
  // North America
  'USA': 'USA',
  'U.S.A.': 'USA',
  'U.S.': 'USA',
  'United States': 'USA',
  'United States of America': 'USA',
  'The United States of America': 'USA',
  'Canada': 'CAN',
  'Mexico': 'MEX',
  'México': 'MEX',

  // Europe
  'UK': 'GBR',
  'U.K.': 'GBR',
  'United Kingdom': 'GBR',
  'Great Britain': 'GBR',
  'England': 'GBR',
  'France': 'FRA',
  'Germany': 'DEU',
  'Deutschland': 'DEU',
  'West Germany': 'DEU',
  'East Germany': 'DEU',
  'Italy': 'ITA',
  'Italia': 'ITA',
  'Spain': 'ESP',
  'España': 'ESP',
  'Portugal': 'PRT',
  'Netherlands': 'NLD',
  'Holland': 'NLD',
  'Belgium': 'BEL',
  'Switzerland': 'CHE',
  'Austria': 'AUT',
  'Greece': 'GRC',
  'Ireland': 'IRL',
  'Sweden': 'SWE',
  'Norway': 'NOR',
  'Denmark': 'DNK',
  'Finland': 'FIN',
  'Poland': 'POL',
  'Polska': 'POL',
  'Hungary': 'HUN',
  'Czech Republic': 'CZE',
  'Czechia': 'CZE',
  'Slovakia': 'SVK',
  'Romania': 'ROU',
  'Bulgaria': 'BGR',
  'Croatia': 'HRV',
  'Serbia': 'SRB',
  'Slovenia': 'SVN',
  'Ukraine': 'UKR',
  'Belarus': 'BLR',
  'Latvia': 'LVA',
  'Estonia': 'EST',
  'Lithuania': 'LTU',

  // Asia
  'Russia': 'RUS',
  'USSR': 'RUS',
  'Soviet Union': 'RUS',
  'China': 'CHN',
  'People\'s Republic of China': 'CHN',
  'PRC': 'CHN',
  'China Republic': 'CHN',
  'China-Szechuan': 'CHN',
  'China-Chihli': 'CHN',
  'China-Hupeh': 'CHN',
  'China-Kwangtung': 'CHN',
  'China-Manchuria': 'CHN',
  'Japan': 'JPN',
  'Japan - Koshu': 'JPN',
  'Japan - Akita': 'JPN',
  'Japan-Akita': 'JPN',
  'India': 'IND',
  'South Korea': 'KOR',
  'Korea, South': 'KOR',
  'North Korea': 'PRK',
  'Korea, North': 'PRK',
  'Vietnam': 'VNM',
  'Thailand': 'THA',
  'Philippines': 'PHL',
  'Singapore': 'SGP',
  'Malaysia': 'MYS',
  'Indonesia': 'IDN',
  'Israel': 'ISR',
  'Turkey': 'TUR',
  'Türkiye': 'TUR',
  'Iran': 'IRN',
  'Saudi Arabia': 'SAU',
  'UAE': 'ARE',
  'United Arab Emirates': 'ARE',
  'Hong Kong': 'HKG',
  'Straits Settlements': 'MYS',

  // Oceania
  'Australia': 'AUS',
  'New Zealand': 'NZL',

  // Africa
  'South Africa': 'ZAF',
  'Egypt': 'EGY',
  'Morocco': 'MAR',
  'Nigeria': 'NGA',
  'Kenya': 'KEN',
  'Ethiopia': 'ETH',
  'Ghana': 'GHA',
  'Tanzania': 'TZA',
  'Algeria': 'DZA',
  'Tunisia': 'TUN',

  // South America
  'Brazil': 'BRA',
  'Brasil': 'BRA',
  'Argentina': 'ARG',
  'Chile': 'CHL',
  'Colombia': 'COL',
  'Peru': 'PER',
  'Venezuela': 'VEN',
  'Uruguay': 'URY',
  'Paraguay': 'PRY',
  'Bolivia': 'BOL',
  'Ecuador': 'ECU',

  // Historical
  'Prussia': 'DEU',
  'Holy Roman Empire': 'DEU',
  'Austrian Empire': 'AUT',
  'Austro-Hungarian Empire': 'AUT',
  'Ottoman Empire': 'TUR',
  'Byzantine Empire': 'TUR',
  'Roman Empire': 'ITA',
  'Ancient Rome': 'ITA',
  'Ancient Greece': 'GRC',
  'Dutch East Indies': 'IDN',
  'British India': 'IND',
  'French Indochina': 'VNM',
  'French Indo China': 'VNM',
  'Ceylon': 'LKA',
  'Siam': 'THA',
  'Persia': 'IRN',
  'Rhodesia': 'ZWE',
  'British Honduras': 'BLZ',
  'New Holland': 'BRA',
  'Spanish Netherlands': 'BEL',
  'Kingdom of Sicily': 'ITA',
  'Kingdom of Naples': 'ITA',
  'Kingdom of Sardinia': 'ITA',
  'Papal States': 'ITA',
  'Venice': 'ITA',
  'Venetian Republic': 'ITA',
  'Kingdom of Poland': 'POL',
  'Polish-Lithuanian Commonwealth': 'POL',
  'Kingdom of Bohemia': 'CZE',
  'Kingdom of Hungary': 'HUN',
  'Kingdom of Prussia': 'DEU',
  'Weimar Republic': 'DEU',
  'Third Reich': 'DEU',
  'Nurnberg': 'DEU',
  'Frankfurt': 'DEU',
  'Confederate States': 'USA',
  'British Empire': 'GBR',
  'British Commonwealth': 'GBR',
  'San Marino': 'SMR',

  // Additional Historical Territories
  'British East India Company': 'IND',
  'Burma': 'MMR',
  'California': 'USA',
  'Central American Republic': 'GTM',
  'China Empire': 'CHN',
  'China-Fengtien': 'CHN',
  'China-Fukien': 'CHN',
  'China-Fujian': 'CHN',
  'China-Kiangnan': 'CHN',
  'China-Kirin': 'CHN',
  'China, People\'s Republic': 'CHN',
  'China-Republic': 'CHN',
  'China Republic': 'CHN',
  'China-Sinkiang': 'CHN',
  'Sicily, Syracuse': 'ITA',
  'China-Taiwan': 'TWN',
  'El Salvador': 'SLV',
  'G.BRITAIN': 'GBR',
  'Guanajuato': 'MEX',
  'Guatemala': 'GTM',
  'Honduras': 'HND',
  'India British': 'IND',
  'India-Hyderabad': 'IND',
  'Indonesia Kupang': 'IDN',
  'Korea': 'KOR',
  'Koshu': 'JPN',
  'LYDIA': 'TUR',
  'Mauritius': 'MUS',
  'Netherlands EIC-Holland': 'NLD',
  'Netherlands E.I.C.-Java': 'IDN',
  'Netherlands E.I.C.-Madura Island': 'IDN',
  'Netherlands-Gelderland': 'NLD',
  'Netherlands-Holland': 'NLD',
  'Netherlands-W.Friesland': 'NLD',
  'Netherlands-Zeeland': 'NLD',
  'North Peru': 'PER',
  'Spanish Philippines': 'PHL',
  'U.S. Philippines': 'PHL'
};

// Function to normalize and map country names
export const normalizeCountry = (countryName) => {
  // Handle null/undefined
  if (!countryName) return null;

  // Normalize string: trim, convert to title case
  const normalized = countryName.trim()
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .replace(/^[a-z]/g, c => c.toUpperCase()) // Capitalize first letter
    .replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase())); // Capitalize after spaces

  // Try direct match
  if (countryVariations[normalized]) {
    return countryVariations[normalized];
  }

  // Try case-insensitive match
  const lowerNormalized = normalized.toLowerCase();
  const match = Object.keys(countryVariations).find(
    key => key.toLowerCase() === lowerNormalized
  );

  return match ? countryVariations[match] : null;
};

// Function to get country name from ISO code
export const getCountryName = (isoCode, geoJsonFeatures) => {
  // First try to find by ISO_A3
  const feature = geoJsonFeatures.find(f => 
    f.properties.ISO_A3 === isoCode || 
    // If ISO_A3 is -99, use ISO_A3_EH instead
    (f.properties.ISO_A3 === "-99" && f.properties.ISO_A3_EH === isoCode)
  );
  return feature ? feature.properties.NAME : isoCode;
};

export default countryVariations;
